import {useCallback} from 'react';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {ConditionalValues} from 'components/customer/Preview3D/types';
import useMaterialTexture from 'components/customer/Preview3D/lib/useMaterialTexture';
import {
    getMultipartFormValues,
    generateMultiPart as getMultiPart,
} from 'components/customer/Preview3DCommon/values/multipart';
import {use3DContext} from 'components/customer/Preview3D/components/Preview3DComponent';

const useMultiPartDynamicValues = () => {
    const {values, productDataStore} = use3DContext();
    const variables: TemplateVariable = JSON.parse(
        productDataStore.current?.template_3d[0].attributes?.variables
    ) as TemplateVariable;
    const {carcaseThickness, exteriorThickness} = useMaterialTexture();
    const formValues = getMultipartFormValues(values);

    const generateMultiPart = useCallback(() => {
        return getMultiPart(
            {
                ...values,
                cabinet_carc_thickness: carcaseThickness,
                cabinet_ext_thickness: exteriorThickness,
            },
            formValues,
            variables
        );
    }, [formValues]);

    const multiPartValues: ConditionalValues[] = [
        {
            key: 'multiPart',
            condition:
                Boolean(formValues.microwaveOpeningHeight) ||
                Boolean(values?.upper_shelves && values?.lower_shelves),
            callback: generateMultiPart,
        },
    ];

    return {
        multiPartValues,
    };
};

export default useMultiPartDynamicValues;
